import { jsxs, jsx } from "react/jsx-runtime";
const IconCopySvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.5 7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H8.333a2.5 2.5 0 0 0-2.5 2.5V5H5a2.5 2.5 0 0 0-2.5 2.5v8.333a2.5 2.5 0 0 0 2.5 2.5h6.667a2.5 2.5 0 0 0 2.5-2.5V15H15a2.5 2.5 0 0 0 2.5-2.5V7.45Zm-5-2.942 2.158 2.159h-1.325a.833.833 0 0 1-.833-.834V4.508Zm0 11.325a.833.833 0 0 1-.833.834H5a.833.833 0 0 1-.833-.834V7.5A.833.833 0 0 1 5 6.667h.833V12.5a2.5 2.5 0 0 0 2.5 2.5H12.5v.833Zm3.333-3.333a.834.834 0 0 1-.833.833H8.333A.833.833 0 0 1 7.5 12.5V4.167a.833.833 0 0 1 .833-.834h2.5v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5V12.5Z" })
    ]
  }
);
export {
  IconCopySvg
};
